"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  accountBalance: 'Account balance',
  add: 'Add',
  addCodeHere: 'Add code here',
  addVoucher: 'Add voucher',
  applied: 'Applied',
  atLeastOneProductMustBeOrdered: 'At least one product must be ordered',
  atpIsDepletedByOtherProcess: 'ATP is depleted by other process / node and reservation cannot be satisfied',
  availableToUseNow: 'Available to use now',
  bonusPoints: 'Bonus Points',
  bonusPointsFromPlacedOrdersInCampaign: 'Bonus Points from placed orders in Campaign {0}. Campaign {0} will end: {1}',
  bp: 'BP',
  bpCount: '{0} BP',
  byClickingFinaliseOrder: 'By clicking "Finalise Order" you are agreeing with our <termsAndConditions>Terms and Conditions</termsAndConditions> and <privacyPolicy>Privacy Policy</privacyPolicy>.',
  cannotOrderSubscriptionBecauseYourDeliveryIsNotOriflameCertifiedOffice: 'Cannot order subscription because your delivery is not Oriflame Certified Office',
  cannotOrderSubscriptionBecauseYourLeaderIsNotAuthorized: 'Cannot order subscription because your leader is not authorized',
  continue: 'Continue',
  credibilityCheckFailed: 'Credibility check failed',
  credit: 'Credit',
  creditIsNotAllowedForCustomersOrder: "Credit is not allowed for customer's order",
  currentActionIsDisabledDuringMaintenance: 'Current action is disabled during maintenance',
  deliveryAddressIsNotAllowedForACustomer: 'Delivery address is not allowed for a customer',
  deliveryAddressIsRequired: 'Delivery address is required',
  deliveryAddressOfACustomerIsNotFound: 'Delivery address of a customer is not found',
  deliveryChannelIsNotAllowedForACustomer: 'Delivery channel is not allowed for a customer',
  discount: 'Discount',
  endConsumerOrderIsAlreadyDroppedOnDifferentOrder: 'End consumer order is already dropped on different order',
  errorCode: 'Error code',
  finaliseOrder: 'Finalise order',
  financeAccountWasAlreadyConsumed: 'Finance account was already consumed',
  group: 'Group',
  homeDelivery: 'Home delivery',
  homeDeliveryAddressDoesntMatchZipTree: "Home delivery address doesn't match zip tree",
  insufficientPrepaymentForPharmacyOrdering: 'Insufficient prepayment for pharmacy ordering',
  invalidShoppingOperation: 'Invalid shopping operation',
  items: 'item(s)',
  logIn: 'Log in',
  meanwhileHaveBeenChangeCataloguesOrRules: 'Meanwhile have been change catalogues or rules',
  meanwhileHaveBeenPlacedOtherOrder: 'Meanwhile have been placed other order',
  ok: 'OK',
  orderSummary: 'Order summary',
  paidWithOriflameWallet: 'Paid with Oriflame Wallet',
  paymentFee: 'Payment fee',
  paymentMethodIsNotAllowed: 'Payment method is not allowed',
  personal: 'Personal',
  pickUpPointDelivery: 'Pick up point delivery',
  placingOrderForTestingShoppingSessionIsNotAllowed: 'Placing order for testing shopping session is not allowed',
  placingOrderWithoutFinishedRegistrationIsNotAllowed: 'Placing order without finished registration is not allowed',
  pleaseWaitAsItsTakingLongerThanExpected: "Please wait as it's taking longer than expected",
  prepaidRemainingX: 'Prepaid (Remaining: {0})',
  productDimensionCanNotFitToTheShoppingBox: 'Product(s) dimension can not fit to the shopping box, Error code',
  productWeightIsOverSmartboxLimit: 'Product(s) weight is over Smartbox limit',
  registerToContinue: 'Register to continue',
  registrationFee: 'Registration fee',
  renewalFee: 'Renewal fee',
  servicesAlreadyDroppedOnDifferentOrder: 'Services already dropped on different order',
  subtotal: 'Subtotal',
  thisMayTakeAMoment: 'This may take a moment so please keep this window open',
  ticketQuantityIsDepletedByOtherProcess: 'Ticket quantity is depleted by other process',
  toOrderThisSubscriptionYouNeed: 'To order this subscription you need either a Life+ Certified Leader in your upline, or delivery to Oriflame Certified Office',
  toOriflameWallet: 'To Oriflame Wallet',
  toPay: 'To pay',
  unableToContinue: 'Unable to continue',
  unauthorizedAccess: 'Unauthorized access',
  underOrderAmountLimit: 'Under order amount limit',
  voucherCode: 'Voucher code',
  voucherCodeIsRequired: 'Voucher code is required',
  voucherCodeIsTooLong: 'Voucher code is too long',
  voucherIsDepletedByOtherProcess: 'Voucher is depleted by other process',
  wallet: 'Wallet',
  walletIsAutoAppliedAndCanCoverUpToXOfYourOrder: 'Wallet is auto-applied and can cover up to 50% of your order. Earnings to the Wallet are processed upon order payment.',
  weAreProcessingYourOrder: 'We are processing your order',
  yourOrderIsSaved: 'Your order has been saved',
  yourOrderIsSavedPaymentRedirect: 'Your order has been saved. Redirecting to payment gate.'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-summary';